import React from 'react'

const PageTitle = (props) => (
    <h1 class="display-4">
        {props.children}
    </h1>
);

export default PageTitle;